const heights = {
  none: 0,
  xxs: '20px',
  xs: '30px',
  sm: '40px',
  md: '50px',
  lg: '60px',
  xl: '70px',
  xxl: '88px',
}

export default heights
